import React, { createContext, useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import withUser from 'containers/User/withUser';
import { ELEVATION_HEIGHT } from '../Map/constants';
import Track from '../../utils/analytics/Track';

export const ElevationContext = createContext({
  map: null,
  setMap: () => {},
  location: null,
  setLocation: () => {},
  showElevation: false,
  setShowElevation: () => {},
});

export function useElevation() {
  return useContext(ElevationContext);
}

export function ElevationProvider({ user, children }) {
  const [map, setMap] = useState(null);
  const [location, setLocation] = useState(null);
  const [showElevation, setShowElevation] = useState(false);

  function setShowElevationWithEffect(show) {
    setShowElevation(show);
    if (show) {
      Track.event({
        category: 'Elevation',
        action: 'Show',
        label: user && user.pm ? 'supporter' : 'free',
      });
    }
    const mapWrapper = document.getElementById('main-map');
    if (show) {
      mapWrapper.classList.add('with-elevation');
      map.panBy([0, ELEVATION_HEIGHT / 2]);
    } else {
      mapWrapper.classList.remove('with-elevation');
      map.panBy([0, -ELEVATION_HEIGHT / 2]);
    }
  }

  const value = useMemo(
    () => ({
      map,
      setMap,
      location,
      setLocation,
      showElevation,
      setShowElevation: setShowElevationWithEffect,
    }),
    [map, location, showElevation],
  );

  return (
    <ElevationContext.Provider value={value}>
      {children}
    </ElevationContext.Provider>
  );
}

ElevationProvider.propTypes = {
  children: PropTypes.node.isRequired,
  user: PropTypes.object,
};

export default withUser(ElevationProvider);
